var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.119 3.75627C11.119 3.75628 11.119 3.75628 11.119 3.75627L7.61897 0.256286C7.27723 -0.0854287 6.72325 -0.0854287 6.38153 0.256286L2.88153 3.75629C2.53982 4.098 2.53982 4.65201 2.88153 4.99373C3.22325 5.33544 3.77726 5.33544 4.11897 4.99373C4.85934 4.25336 6.12527 4.77772 6.12527 5.82476V10.5C6.12527 10.9832 6.51702 11.375 7.00027 11.375C7.48351 11.375 7.87527 10.9832 7.87527 10.5V5.82472C7.87527 4.77769 9.14117 4.25334 9.88153 4.9937C10.0524 5.16457 10.2763 5.24999 10.5003 5.24999C10.7242 5.24999 10.9481 5.16457 11.119 4.9937C11.4607 4.65199 11.4607 4.09799 11.119 3.75627C11.119 3.75626 11.119 3.75626 11.119 3.75627Z",
    fill: "#353535"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5001 14H3.50012C1.5702 14 0.00012207 12.4299 0.00012207 10.5V7.875C0.00012207 7.39175 0.391876 7 0.875122 7C1.35837 7 1.75012 7.39175 1.75012 7.875V10.5C1.75012 11.465 2.53516 12.25 3.50012 12.25H10.5001C11.4651 12.25 12.2501 11.465 12.2501 10.5V7.875C12.2501 7.39175 12.6419 7 13.1251 7C13.6084 7 14.0001 7.39175 14.0001 7.875V10.5C14.0001 12.4299 12.43 14 10.5001 14Z",
    fill: "#353535"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.34737938d5ff578ecfad352c116e48d9.svg";
export { ForwardRef as ReactComponent };